<rt-dropdown rtScrollable [rtScrollableSuppressScrollX]="true" class="stages-dropdown">
  <rt-dropdown-header (click)="$event.preventDefault()">
    {{ 'app.candidate.move_to_stage' | translate }}
  </rt-dropdown-header>
  <div rtScrollable [rtScrollableSuppressScrollX]="true" class="scroll-content">
    @for (stage of stagesWithProgress; track trackById($index, stage)) {
      <div>
        @if (stage.isFirstGroupStage && stage.useStageGrouping) {
          <rt-dropdown-header [isSubheading]="true">
            {{ stageGroupTranslations[stage.group] }}
          </rt-dropdown-header>
        }
        <rt-stage-item
          [title]="stage.name"
          [isCurrent]="stage.progress === 'current'"
          [showHiredIcon]="stage.group === 'hires' && !stage.useStageGrouping"
          [disabled]="!stage.accessToGroup && stage.progress !== 'current'"
          [clickable]="canProceed"
          [hasAutomatedActions]="stage.hasAutomatedActions"
          [timeLimit]="stage.timeLimit"
          [unbiasedHiringEnabled]="
            stage.fairEvaluationsEnabled || stage.candidateAnonymizationEnabled
          "
          [tooltipCopy]="stage.tooltipCopy"
          (showDetailsClick)="showDetailsClick.emit(stage)"
          (stageClick)="onStageClick(placement, stage)"
        ></rt-stage-item>
      </div>
    }
  </div>
</rt-dropdown>
